import React from 'react';
import './ViewerPdf.css';

const PdfViewer = ({ blobUrl, fileName }) => {
  const BASE_URL = process.env.REACT_APP_REDIRECT_URI;
  const viewerUrl = `${BASE_URL}/js/pdfjs/web/viewer.html?file=${encodeURIComponent(blobUrl)}&originPage=${encodeURIComponent(window.location.pathname)}`;

  return (
    <div className="pdfViewerContainer">
      {blobUrl ? (
        <iframe
          src={viewerUrl}
          width="100%"
          height="750px"
          style={{ border: 'none' }}
          title={fileName}
        ></iframe>
      ) : (
        <p>Loading PDF...</p>
      )}
    </div>
  );
};

export default PdfViewer;
